import SalesStep3Component from './SalesStep3';

export { SalesStep3Component as SalesStep3 };
export { useSalesStep3 } from './SalesStep3.hooks';
export * from './SalesStep3.styles';

export default SalesStep3Component;
